import { extend } from '@react-three/fiber';
import { shaderMaterial } from '@react-three/drei';
import fragmentShader from './EclipseMaterial.frag';
import vertexShader from './EclipseMaterial.vert';
import { Vector2, Color } from 'three';

const EclipseMaterial = shaderMaterial(
  {
    time: 1,
    uvScale: new Vector2(1, 1),
    texture1: null,
    texture2: null,
    fogNearColor: new Color(0.2, 0.3, 0.4),
    fogHorizonColor: new Color(0.2, 0.3, 0.4),
    fogDensity: 0.0025,
    fogNoiseSpeed: 100,
    fogNoiseFreq: 0.052,
    fogNoiseImpact: 0.1,
    fogCeiling: 25.00001,
    fogFloor: 12.00001,
  },
  vertexShader,
  fragmentShader,
);

extend({ EclipseMaterial });